// Official Viral Vision Media logo lockup.
export const Logo = ({ light = false, className = "", testid = "logo" }) => {
  if (light) {
    return (
      <span className={`inline-flex items-center rounded-xl bg-[#FAF7F2] px-3 py-2 ${className}`} data-testid={testid}>
        <img src="/logo.png" alt="Viral Vision Media" className="h-10 w-auto object-contain" />
      </span>
    );
  }
  return (
    <span className={`inline-flex items-center ${className}`} data-testid={testid}>
      <img src="/logo.png" alt="Viral Vision Media" className="h-14 md:h-16 w-auto object-contain mix-blend-multiply" />
    </span>
  );
};

export default Logo;
